import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { SITES_PROVIDER } from './sites-provider.token';

/**
 * Redirects an authenticated user with zero sites to `/app/onboarding`. Moved here from
 * privaci-app (US-C3-2) so privaci-admin can reuse it; depends on `SITES_PROVIDER`, not a
 * concrete app service, so this library carries no app-specific coupling.
 */
export const onboardingGuard: CanActivateFn = () => {
  const sites = inject(SITES_PROVIDER);
  const router = inject(Router);

  if (sites.sites().length > 0) return true;

  return sites.loadSites().pipe(
    map((siteList) => (siteList.length > 0 ? true : router.createUrlTree(['/app/onboarding']))),
    // A network error shouldn't strand the user on a guard failure — let the route proceed and
    // let the page's own API calls surface the real error.
    catchError(() => of(true)),
  );
};
